import _taggedTemplateLiteralLoose from "@babel/runtime/helpers/taggedTemplateLiteralLoose";
var _templateObject;
import styled from 'styled-components';
export var Input = styled.input(_templateObject || (_templateObject = _taggedTemplateLiteralLoose(["\n  padding: 0.3rem 0.3rem;\n  border: 1px solid #00000024;\n  border-radius: 0.2rem;\n  position: sticky;\n  top: 8px;\n  z-index: 9;\n"])));